// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2Qbwd","loaderOuter":"PageOverlayLoader_loaderOuter__2dV_7"};